import { render, staticRenderFns } from "./GogoReliable.vue?vue&type=template&id=2f9fa091&scoped=true"
var script = {}
import style0 from "./GogoReliable.vue?vue&type=style&index=0&id=2f9fa091&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9fa091",
  null
  
)

export default component.exports